import useSWR from 'swr';
import api from '../../config/configApi';

const buildQueryString = (filtros = {}) => {
  const params = new URLSearchParams();
  Object.entries(filtros).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      params.append(key, value);
    }
  });
  const query = params.toString();
  return query ? `?${query}` : '';
};

const fetcher = async (url) => {
  try {
    const { data } = await api.get(url);

    if (data?.erro) {
      throw new Error(data?.mensagem || 'Erro na API');
    }

    return data?.tarefas ?? [];
  } catch (err) {
    console.error('Erro ao buscar tarefas de contato:', err?.response?.status, err?.message);
    return [];
  }
};

// `ativo: false` não consulta o servidor (ex.: sino do topo para quem não tem acesso às tarefas).
export default function useTarefasContato(filtros = {}, { ativo = true } = {}) {
  const {
    data: tarefas = [], error, isLoading, mutate,
  } = useSWR(
    ativo ? `/tarefas-contato${buildQueryString(filtros)}` : null,
    fetcher,
  );

  const criarTarefa = async (payload) => {
    const { data } = await api.post('/tarefas-contato', payload);
    await mutate();
    return data?.tarefaContato;
  };

  const editarTarefa = async (id, payload) => {
    const { data } = await api.patch(`/tarefas-contato/${id}`, payload);
    await mutate();
    return data?.tarefaContato;
  };

  const concluirTarefa = async (id, { concluidoEm, proximaTarefa } = {}) => {
    const { data } = await api.patch(`/tarefas-contato/${id}/concluir`, {
      ...(concluidoEm ? { concluidoEm } : {}),
      ...(proximaTarefa ? { proximaTarefa } : {}),
    });
    await mutate();
    return data;
  };

  const cancelarTarefa = async (id, motivoCancelamento) => {
    const { data } = await api.patch(`/tarefas-contato/${id}/cancelar`, { motivoCancelamento });
    await mutate();
    return data?.tarefaContato;
  };

  const iniciarAtendimento = async (id) => {
    const { data } = await api.patch(`/tarefas-contato/${id}/iniciar-atendimento`);
    await mutate();
    return data?.tarefaContato;
  };

  const liberarAtendimento = async (id) => {
    const { data } = await api.patch(`/tarefas-contato/${id}/liberar-atendimento`);
    await mutate();
    return data?.tarefaContato;
  };

  return {
    tarefas,
    isLoading,
    isError: !!error,
    criarTarefa,
    editarTarefa,
    concluirTarefa,
    cancelarTarefa,
    iniciarAtendimento,
    liberarAtendimento,
    refetch: mutate,
  };
}
